import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#1e3a8a] text-white/40 py-8 border-t border-white/10" data-id="element-49">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-51">
            <p className="text-sm text-center md:text-left" data-id="element-52">
              © {new Date().getFullYear()} Meal Prep para Cerebro Saturado.
              Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-53">
              <button onClick={() => setShowPrivacy(true)} className="text-sm text-white/60 hover:text-white transition-colors underline" data-id="element-54">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-sm text-white/60 hover:text-white transition-colors underline" data-id="element-55">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-56">
        <div className="prose prose-sm max-w-none text-[#4B5563]" data-id="element-57">
          <p className="mb-4" data-id="element-58">
            <strong data-id="element-59">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES')}
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-60">
            1. Información que Recopilamos
          </h3>
          <p className="mb-4" data-id="element-61">
            Cuando compras nuestro ebook "Meal Prep para Cerebro Saturado",
            recopilamos información necesaria para procesar tu compra,
            incluyendo:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-62">
            <li data-id="element-63">Nombre y dirección de correo electrónico</li>
            <li data-id="element-64">
              Información de pago (procesada de forma segura por nuestro
              proveedor de pagos)
            </li>
            <li data-id="element-65">Dirección IP y datos de navegación</li>
          </ul>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-66">
            2. Uso de la Información
          </h3>
          <p className="mb-4" data-id="element-67">Utilizamos tu información para:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-68">
            <li data-id="element-69">Procesar y entregar tu compra del ebook</li>
            <li data-id="element-70">Enviar confirmaciones y actualizaciones sobre tu pedido</li>
            <li data-id="element-71">Proporcionar soporte al cliente</li>
            <li data-id="element-72">Mejorar nuestros productos y servicios</li>
          </ul>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-73">
            3. Protección de Datos
          </h3>
          <p className="mb-4" data-id="element-74">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-75">
            4. Compartir Información
          </h3>
          <p className="mb-4" data-id="element-76">
            No vendemos ni compartimos tu información personal con terceros,
            excepto cuando sea necesario para procesar pagos o cumplir con
            obligaciones legales.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-77">
            5. Tus Derechos
          </h3>
          <p className="mb-4" data-id="element-78">Tienes derecho a:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-79">
            <li data-id="element-80">Acceder a tu información personal</li>
            <li data-id="element-81">Solicitar correcciones o eliminación de tus datos</li>
            <li data-id="element-82">Retirar tu consentimiento en cualquier momento</li>
            <li data-id="element-83">
              Presentar una queja ante la autoridad de protección de datos
            </li>
          </ul>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-84">
            6. Cookies
          </h3>
          <p className="mb-4" data-id="element-85">
            Utilizamos cookies para mejorar tu experiencia de navegación y
            analizar el uso de nuestro sitio web. Puedes configurar tu navegador
            para rechazar cookies.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-86">
            7. Cambios a esta Política
          </h3>
          <p className="mb-4" data-id="element-87">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos publicando la nueva
            política en esta página.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-88">
            8. Contacto
          </h3>
          <p className="mb-4" data-id="element-89">
            Si tienes preguntas sobre esta política de privacidad, contáctanos a
            través del correo electrónico proporcionado en tu compra.
          </p>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-90">
        <div className="prose prose-sm max-w-none text-[#4B5563]" data-id="element-91">
          <p className="mb-4" data-id="element-92">
            <strong data-id="element-93">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES')}
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-94">
            1. Aceptación de Términos
          </h3>
          <p className="mb-4" data-id="element-95">
            Al comprar y descargar el ebook "Meal Prep para Cerebro Saturado -
            Método 3-3-7", aceptas estos términos y condiciones en su totalidad.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-96">
            2. Descripción del Producto
          </h3>
          <p className="mb-4" data-id="element-97">
            El ebook "Meal Prep para Cerebro Saturado" es un producto digital
            que proporciona:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-98">
            <li data-id="element-99">Guía del Método 3-3-7 para organización de comidas</li>
            <li data-id="element-100">Listas de compras y plantillas imprimibles</li>
            <li data-id="element-101">Menú de emergencia y rutinas de mantenimiento</li>
            <li data-id="element-102">Acceso de por vida al contenido digital</li>
          </ul>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-103">
            3. Precio y Pago
          </h3>
          <p className="mb-4" data-id="element-104">
            El precio del ebook es de $6.39 USD (precio con descuento desde
            $19.99). Los pagos se procesan de forma segura a través de nuestro
            proveedor de pagos. Todas las ventas son finales.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-105">
            4. Entrega del Producto
          </h3>
          <p className="mb-4" data-id="element-106">
            Después de completar tu compra, recibirás un enlace de descarga
            inmediata por correo electrónico. El ebook estará disponible en
            formato PDF.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-107">
            5. Política de Reembolso
          </h3>
          <p className="mb-4" data-id="element-108">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecho con el ebook, contáctanos dentro de los 30 días
            posteriores a la compra para solicitar un reembolso completo.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-109">
            6. Propiedad Intelectual
          </h3>
          <p className="mb-4" data-id="element-110">
            Todo el contenido del ebook, incluyendo texto, imágenes y diseño,
            está protegido por derechos de autor. No está permitido:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-111">
            <li data-id="element-112">Reproducir o distribuir el contenido sin autorización</li>
            <li data-id="element-113">Vender o revender el ebook</li>
            <li data-id="element-114">Modificar o crear obras derivadas</li>
            <li data-id="element-115">Compartir el archivo con terceros</li>
          </ul>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-116">
            7. Uso Permitido
          </h3>
          <p className="mb-4" data-id="element-117">
            Puedes usar el ebook para tu uso personal. Puedes imprimirlo para tu
            uso personal. No puedes compartirlo, distribuirlo o usarlo con fines
            comerciales.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-118">
            8. Descargo de Responsabilidad
          </h3>
          <p className="mb-4" data-id="element-119">
            El contenido del ebook es solo para fines informativos y educativos.
            No sustituye el consejo médico o nutricional profesional. Consulta
            con un profesional de la salud antes de hacer cambios significativos
            en tu dieta.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-120">
            9. Limitación de Responsabilidad
          </h3>
          <p className="mb-4" data-id="element-121">
            No somos responsables de ningún daño directo, indirecto, incidental
            o consecuente que resulte del uso o la imposibilidad de usar el
            ebook.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-122">
            10. Modificaciones
          </h3>
          <p className="mb-4" data-id="element-123">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-124">
            11. Ley Aplicable
          </h3>
          <p className="mb-4" data-id="element-125">
            Estos términos se rigen por las leyes aplicables en tu jurisdicción.
            Cualquier disputa se resolverá en los tribunales competentes.
          </p>

          <h3 className="text-lg font-bold text-[#1F2937] mt-6 mb-3" data-id="element-126">
            12. Contacto
          </h3>
          <p className="mb-4" data-id="element-127">
            Para preguntas sobre estos términos, contáctanos a través del correo
            electrónico proporcionado en tu confirmación de compra.
          </p>
        </div>
      </Modal>
    </>;
}